/* ============================================================
   OCBON V4 — Interactions + Shopify cart flow
   Bundle builder, reveal on scroll, FAQ expand, smooth scroll
   ============================================================ */
(function () {
  "use strict";

  /* ---------- Reveal on scroll (runs regardless of builder) ---------- */
  var revealEls = [].slice.call(document.querySelectorAll(".v4-reveal"));
  function checkReveal() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = revealEls.length - 1; i >= 0; i--) {
      var el = revealEls[i];
      var r = el.getBoundingClientRect();
      if (r.top < vh - 48 && r.bottom > 0) {
        el.classList.add("in");
        revealEls.splice(i, 1);
      }
    }
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { checkReveal(); ticking = false; });
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  checkReveal();
  window.addEventListener("load", function () {
    checkReveal();
    setTimeout(function () {
      if (document.querySelectorAll(".v4-reveal.in").length === 0) {
        revealEls.forEach(function (el) { el.classList.add("in"); });
      }
    }, 900);
  });

  /* ---------- Ingredient expand/collapse (runs regardless of builder) ---------- */
  document.querySelectorAll(".v4-ingredient__more").forEach(function (btn) {
    var card = btn.closest(".v4-ingredient");
    var section = card ? card.closest("section") : null;
    var readMore = (section && section.getAttribute("data-read-more")) || "Read more";
    var readLess = (section && section.getAttribute("data-read-less")) || "Read less";
    btn.innerHTML = readMore + " <span>+</span>";
    btn.addEventListener("click", function () {
      var open = card.classList.toggle("is-open");
      btn.innerHTML = open
        ? readLess + " <span>&#8722;</span>"
        : readMore + " <span>+</span>";
    });
  });

  /* ---------- Smooth scroll for in-page anchors (runs regardless of builder) ---------- */
  document.querySelectorAll("a[href^='#']").forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href");
      if (id.length < 2) return;
      var tgt = document.querySelector(id);
      if (tgt) {
        e.preventDefault();
        var y = tgt.getBoundingClientRect().top + window.pageYOffset - 76;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    });
  });

  /* ---------- Bundle builder ---------- */
  var builderEl = document.querySelector("[data-ocv4-builder]");
  if (!builderEl) return;

  var DISCOUNT_CODE  = builderEl.getAttribute("data-discount")      || "OCBON50";
  var SELLING_PLAN   = builderEl.getAttribute("data-selling-plan")   || "";
  var MIN_ITEMS      = parseInt(builderEl.getAttribute("data-min")   || "3", 10);

  /* Locale strings from section data attributes — allows Spanish (or any language) pages */
  var LOC_CLAIM    = builderEl.getAttribute("data-loc-claim")    || "Claim 50% Off";
  var LOC_ADD_N    = builderEl.getAttribute("data-loc-add-n")    || "Add N to continue";
  var LOC_SELECTED = builderEl.getAttribute("data-loc-selected") || "N selected · add M more";
  var LOC_DONE     = builderEl.getAttribute("data-loc-done")     || "N selected";
  var LOC_ADD_MORE = builderEl.getAttribute("data-loc-add-more") || "Add M more to continue";
  var LOC_ADDING   = builderEl.getAttribute("data-loc-adding")   || "Adding to cart…";
  var LOC_EMPTY    = builderEl.getAttribute("data-loc-empty")    || "No products selected yet.";

  /* Replace N/M tokens with bold numbers */
  function locFmt(tpl, n, m) {
    return tpl
      .replace(/\bN\b/g, n !== undefined ? "<b>" + n + "</b>" : "")
      .replace(/\bM\b/g, m !== undefined ? "<b>" + m + "</b>" : "");
  }

  var PRODUCTS = JSON.parse(builderEl.getAttribute("data-products") || "[]");
  var qty = {};
  PRODUCTS.forEach(function (p) { qty[p.id] = 0; });

  var listEl    = builderEl.querySelector("[data-bb='list']");
  var linesEl   = builderEl.querySelector("[data-bb='lines']");
  var progFill  = builderEl.querySelector("[data-bb='prog-fill']");
  var progLabel = builderEl.querySelector("[data-bb='prog-label']");
  var saveEl    = builderEl.querySelector("[data-bb='save']");
  var grandEl   = builderEl.querySelector("[data-bb='grand']");
  var wasEl     = builderEl.querySelector("[data-bb='was']");
  var ctaEl     = builderEl.querySelector("[data-bb='cta']");
  var cartCount = document.querySelector("[data-ocv4='cart-count']");

  function money(n) { return "$" + n.toFixed(2); }
  function totalItems() {
    return PRODUCTS.reduce(function (s, p) { return s + qty[p.id]; }, 0);
  }

  /* Render product cards */
  function renderCards() {
    if (!listEl) return;
    var html = "";
    var lastGroup = null;
    PRODUCTS.forEach(function (p) {
      if (p.group !== lastGroup) {
        html += '<div class="v4-product-group-label">' + p.group + "</div>";
        lastGroup = p.group;
      }
      var q = qty[p.id];
      html +=
        '<div class="v4-product-card' + (q > 0 ? " is-selected" : "") + '" data-card="' + p.id + '">' +
          '<img class="v4-product-card__img" src="' + p.img + '" alt="' + p.name + '" loading="lazy">' +
          '<div class="v4-product-card__info">' +
            '<h4>' + p.name + "</h4>" +
            '<div class="v4-product-card__meta">' + p.size + "</div>" +
            '<div class="v4-product-card__price"><del>' + money(p.was) + "</del><ins>" + money(p.now) + "</ins></div>" +
            (p.tag ? '<span class="v4-product-card__tag">' + p.tag + "</span>" : "") +
          "</div>" +
          '<div class="v4-product-card__action">' +
            (q > 0
              ? '<div class="v4-stepper">' +
                  '<button data-dec="' + p.id + '" aria-label="Decrease">&#8722;</button>' +
                  "<output>" + q + "</output>" +
                  '<button data-inc="' + p.id + '" aria-label="Increase">+</button>' +
                "</div>"
              : '<button class="v4-product-card__add" data-add="' + p.id + '">Add</button>') +
          "</div>" +
        "</div>";
    });
    listEl.innerHTML = html;
  }

  /* Render summary sidebar */
  function renderSummary() {
    var items = totalItems();
    var sub = 0, was = 0;
    var lines = "";
    PRODUCTS.forEach(function (p) {
      if (qty[p.id] > 0) {
        sub += qty[p.id] * p.now;
        was += qty[p.id] * p.was;
        lines += '<div class="v4-bb-line"><span>' + qty[p.id] + "&#215; " + p.name + "</span><b>" + money(qty[p.id] * p.now) + "</b></div>";
      }
    });
    if (linesEl) {
      linesEl.innerHTML = items > 0 ? lines : '<div class="v4-bb-empty">' + LOC_EMPTY + "</div>";
    }

    var pct = Math.min(100, (items / MIN_ITEMS) * 100);
    if (progFill) progFill.style.width = pct + "%";
    if (progLabel) {
      if (items === 0)            progLabel.innerHTML = locFmt(LOC_ADD_N, MIN_ITEMS);
      else if (items < MIN_ITEMS) progLabel.innerHTML = locFmt(LOC_SELECTED, items, MIN_ITEMS - items);
      else                        progLabel.innerHTML = locFmt(LOC_DONE, items) + " &#10003;";
    }

    if (wasEl)   wasEl.textContent   = money(was);
    if (saveEl)  saveEl.textContent  = "-" + money(was - sub);
    if (grandEl) grandEl.textContent = money(sub);

    var ready = items >= MIN_ITEMS;
    if (ctaEl) {
      ctaEl.disabled = !ready;
      ctaEl.innerHTML = ready
        ? LOC_CLAIM + " &middot; " + money(sub) + ' <span class="v4-arrow">&#8594;</span>'
        : locFmt(LOC_ADD_MORE, "", MIN_ITEMS - items);
    }
    if (cartCount) {
      cartCount.textContent = items;
      cartCount.style.display = items > 0 ? "grid" : "none";
    }
  }

  function update() { renderCards(); renderSummary(); }

  /* Delegated click handler on product list */
  if (listEl) {
    listEl.addEventListener("click", function (e) {
      var t = e.target.closest("button");
      if (!t) return;
      var add = t.getAttribute("data-add");
      var inc = t.getAttribute("data-inc");
      var dec = t.getAttribute("data-dec");
      if (add)       { qty[add] = 1;                         update(); }
      else if (inc)  { qty[inc] = Math.min(9, qty[inc] + 1); update(); }
      else if (dec)  { qty[dec] = Math.max(0, qty[dec] - 1); update(); }
    });
  }

  /* CTA — Shopify cart add + checkout redirect */
  if (ctaEl) {
    ctaEl.addEventListener("click", function () {
      if (ctaEl.disabled) return;

      ctaEl.disabled = true;
      ctaEl.textContent = LOC_ADDING;

      var items = [];
      PRODUCTS.forEach(function (p) {
        if (qty[p.id] > 0) {
          var item = { id: parseInt(p.variantId, 10), quantity: qty[p.id] };
          if (SELLING_PLAN) item.selling_plan = parseInt(SELLING_PLAN, 10);
          items.push(item);
        }
      });

      fetch("/cart/clear.js", { method: "POST" })
        .then(function () {
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: items }),
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error("cart/add.js failed: " + res.status);
          window.location.href = "/checkout?discount=" + encodeURIComponent(DISCOUNT_CODE);
        })
        .catch(function (err) {
          console.error("OCBON V4 cart error:", err);
          ctaEl.disabled = false;
          renderSummary();
        });
    });
  }

  update();

})();
